<div id="<%= dom_id(clip) %>" class="bg-white rounded-lg shadow-md p-4">
  <div class="flex justify-between items-start mb-3">
    <div>
      <h3 class="font-semibold text-lg"><%= clip.name %></h3>
      <span class="text-gray-500 text-sm">
        <%= clip.created_at.strftime("%b %d, %Y at %H:%M") %>
        <% if clip.duration %>
          &middot; <%= clip.duration.round(1) %>s
        <% end %>
      </span>
    </div>
    <%= button_to "Delete", clip_path(clip), method: :delete,
        class: "text-red-500 hover:text-red-700 text-sm font-medium",
        data: { turbo_confirm: "Delete this clip?" } %>
  </div>

  <% if clip.audio.attached? %>
    <audio controls class="w-full mb-3">
      <source src="<%= clip.audio.url %>" type="<%= clip.audio.content_type %>">
    </audio>
  <% end %>

  <% if clip.transcript.present? %>
    <div class="bg-gray-50 rounded p-3 mb-2">
      <p class="text-gray-500 text-xs font-medium mb-1">English</p>
      <p class="text-gray-700 text-sm"><%= clip.transcript %></p>
    </div>
  <% end %>

  <% if clip.translation.present? %>
    <div class="bg-purple-50 rounded p-3">
      <p class="text-purple-500 text-xs font-medium mb-1">Espa&ntilde;ol</p>
      <p class="text-gray-700 text-sm"><%= clip.translation %></p>
    </div>
  <% else %>
    <% unless clip.transcript.present? %>
      <p class="text-gray-400 text-sm italic">No transcript available</p>
    <% end %>
  <% end %>
</div>
